// Parser markdown minimalista para o widget.
// Cobre: **bold**, _italic_, `code`, listas 1. / -, quebras de linha, links [txt](url).
// Escapa HTML primeiro (defesa contra qualquer coisa que venha do agent).
// Zero dependências.

function escapeHtml(s) {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function inline(s) {
  return s
    .replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>')
    // exige não-palavra antes e depois, para não partir snake_case
    .replace(/(^|\W)_([^_\n]+)_(?=\W|$)/g, '$1<em>$2</em>')
    .replace(/`([^`\n]+)`/g, '<code>$1</code>')
    .replace(/\[([^\]\n]+)\]\((https?:[^)\s]+)\)/g, (m, t, u) => '<a href="' + u + '" target="_blank" rel="noopener noreferrer">' + t + '</a>')
}

export function renderMarkdown(text) {
  if (!text) return ''
  const esc = escapeHtml(text)
  const lines = esc.split(/\r?\n/)
  const out = []
  let listType = null

  const closeList = () => {
    if (listType) { out.push('</' + listType + '>'); listType = null }
  }

  for (const raw of lines) {
    const line = raw
    const ol = line.match(/^\s*\d+\.\s+(.+)$/)
    const ul = line.match(/^\s*[-*]\s+(.+)$/)
    if (ol) {
      if (listType !== 'ol') { closeList(); out.push('<ol>'); listType = 'ol' }
      out.push('<li>' + inline(ol[1]) + '</li>')
    } else if (ul) {
      if (listType !== 'ul') { closeList(); out.push('<ul>'); listType = 'ul' }
      out.push('<li>' + inline(ul[1]) + '</li>')
    } else if (line.trim() === '') {
      closeList()
      out.push('<br>')
    } else {
      closeList()
      out.push(inline(line))
    }
  }
  closeList()
  // Juntar linhas normais com <br>, mas manter listas coladas
  return out.reduce((acc, cur, i) => {
    const prev = out[i - 1] || ''
    const needBr = i > 0 && !prev.match(/<\/?(?:ol|ul|li|br)/) && !cur.match(/<\/?(?:ol|ul|li|br)/)
    return acc + (needBr ? '<br>' : '') + cur
  }, '')
}
